import React from "react";
import styles from './InputWithMask.module.scss';
import InputMask from "react-input-mask";

const InputWithMask = ({
  label,
  className,
  onChange,
  onClickRightIcon,
  value,
  name,
  labelStyle,
  rightIcon,
  backgroundStyle,
  inputStyle,
  bottomString,
  refFocus,
  onKeyPress,
  type,
  autoFocus,
  multiple,
  placeholder,
  readOnly = false,
}) => {
  return (
    <div className={`${styles.container} ${className}`}>
      <div className={`${styles.background} ${backgroundStyle}`}>
        <label className={` ${labelStyle} ${styles.label}`}>{label}</label>
      </div>
      <InputMask
        mask="7 999 - 999 - 99 - 99"
        className={`${styles.input} ${inputStyle}`}
        onChange={onChange}
        value={value}
        name={name}
        ref={refFocus}
        onKeyPress={onKeyPress}
        autoFocus={autoFocus}
        type={type}
        multiple={multiple}
        placeholder={placeholder}
        readOnly={readOnly}
      >
        {(inputProps) => <input {...inputProps} />}
      </InputMask>
      <div className={styles.rightIcon} onClick={onClickRightIcon}>
        {rightIcon}
      </div>
      {bottomString && (
        <p className={`${styles.bottomString}`}>{bottomString}</p>
      )}
    </div>
  );
};

export default InputWithMask;
